module.exports = __webpack_public_path__ + "static/media/all-rounder-icon.9ac62d06.svg";